import React from "react";
import clsx from "clsx";

export function SimpleLogo({className}) {
    return (<>
        <svg
            className={clsx('logo', className)}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 194.3 91.8"
        >
            <defs>
                <style
                    dangerouslySetInnerHTML={{
                        __html:
                            ".cls-1{fill:#1e2d5c;}.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient);}"
                    }}
                />
                <linearGradient
                    id="linear-gradient"
                    x1="11.35"
                    y1="35.2"
                    x2="164.09"
                    y2="35.2"
                    gradientTransform="matrix(1.03, 0.15, -0.16, 0.99, -0.56, -12.5)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset={0} stopColor="#ef4136"/>
                    <stop offset="0.06" stopColor="#ef4635"/>
                    <stop offset="0.41" stopColor="#f15d2c"/>
                    <stop offset="0.73" stopColor="#f26925"/>
                    <stop offset={1} stopColor="#f26d23"/>
                </linearGradient>
            </defs>
            <rect
                className="cls-1"
                x="39.16"
                y="50.78"
                width="146.64"
                height="24.94"
                transform="matrix(0.99, -0.16, 0.16, 0.99, -8.6, 18.62)"
            />
            <path
                className="cls-2"
                d="M55.36,74.33A2,2,0,0,0,57,73.23l1,.37a3.28,3.28,0,0,1-2.44,1.83,3,3,0,0,1-3.66-2.69,3.15,3.15,0,1,1,6.22-1v.48L53,73A1.86,1.86,0,0,0,55.36,74.33Zm-2.56-2.2,4-.61a2,2,0,0,0-2.19-1.46A2.09,2.09,0,0,0,52.8,72.13Z"
            />
            <path
                className="cls-2"
                d="M65.49,73.6l-2.08-2-1.22,2.57L61,74.45,62.8,71l-2.68-2.56,1.22-.24,1.83,1.83,1.22-2.32,1.22-.24L63.9,70.79l2.81,2.68Z"
            />
            <path
                className="cls-2"
                d="M75.62,69a3.19,3.19,0,0,1-2.57,3.66,2.59,2.59,0,0,1-2.44-.85l.49,3.41-1.1.13-1.1-8.42,1.1-.13.12,1a2.85,2.85,0,0,1,2.08-1.59A3.21,3.21,0,0,1,75.62,69Zm-1,.12a2.16,2.16,0,1,0-1.83,2.44A2.11,2.11,0,0,0,74.64,69.08Z"
            />
            <path
                className="cls-2"
                d="M82.33,70.06A2,2,0,0,0,83.91,69l1,.37a3.3,3.3,0,0,1-2.44,1.83,3,3,0,0,1-3.66-2.69,3.15,3.15,0,1,1,6.22-1V68l-5,.86C80.25,69.81,81.23,70.18,82.33,70.06Zm-2.57-2.2,4-.61a2,2,0,0,0-2.2-1.46A1.92,1.92,0,0,0,79.76,67.86Z"
            />
            <path
                className="cls-2"
                d="M90.62,63.35l.13,1.09a1.72,1.72,0,0,0-1.59,2.08l.49,3.17-1.1.12-1-6,1.1-.12.12,1A2.27,2.27,0,0,1,90.62,63.35Z"
            />
            <path
                className="cls-2"
                d="M93.31,61.15c-.12-.37.24-.73.61-.85s.73.24.85.61a.91.91,0,0,1-.61.85C93.68,61.76,93.31,61.52,93.31,61.15ZM93.8,63l1.1-.12,1,6-1.1.12Z"
            />
            <path
                className="cls-2"
                d="M102.22,66.89a2,2,0,0,0,1.58-1.1l1,.36A3.26,3.26,0,0,1,102.34,68a3,3,0,0,1-3.66-2.68,3.15,3.15,0,1,1,6.22-1v.49l-5,.86A2,2,0,0,0,102.22,66.89Zm-2.57-2.32,4-.61a2,2,0,0,0-2.2-1.47A2.11,2.11,0,0,0,99.65,64.57Z"
            />
            <path
                className="cls-2"
                d="M113.32,62.13l.61,3.66-1.1.12-.61-3.66a1.43,1.43,0,0,0-1.71-1.34c-1,.12-1.58.85-1.46,2.19l.49,3.18-1.1.12-1-6,1.1-.12.12.85a2.36,2.36,0,0,1,1.83-1.34A2.67,2.67,0,0,1,113.32,62.13Z"
            />
            <path
                className="cls-2"
                d="M116.74,62.25a3.17,3.17,0,0,1,2.68-3.66,2.84,2.84,0,0,1,2.93,1.1l-.73.61a1.85,1.85,0,0,0-2-.74A2,2,0,0,0,118,62a2.17,2.17,0,0,0,2.44,1.83A1.85,1.85,0,0,0,122,62.49l1,.37a2.93,2.93,0,0,1-2.44,2A3,3,0,0,1,116.74,62.25Z"
            />
            <path
                className="cls-2"
                d="M128.82,62.61a2,2,0,0,0,1.58-1.09l1,.36a3.24,3.24,0,0,1-2.44,1.83A3,3,0,0,1,125.28,61a3.15,3.15,0,1,1,6.22-1v.49l-5,.85A2,2,0,0,0,128.82,62.61Zm-2.56-2.31,4-.61a2,2,0,0,0-2.19-1.47A2,2,0,0,0,126.26,60.3Z"
            />
            <path
                className="cls-2"
                d="M148.46,56.39l.61,3.66-1.09.12-.61-3.66a1.27,1.27,0,0,0-1.59-1.22c-.85.12-1.34.74-1.22,2.08l.49,3.29-1.1.12-.61-3.66c-.12-1-.73-1.34-1.46-1.22s-1.47.74-1.22,2.08l.48,3.29-1.1.12-1-6,1.1-.12.12.86a2,2,0,0,1,1.59-1.22,1.92,1.92,0,0,1,2,.73,2.33,2.33,0,0,1,1.71-1.34A2.45,2.45,0,0,1,148.46,56.39Z"
            />
            <path
                className="cls-2"
                d="M151.88,56.64a3.21,3.21,0,1,1,3.66,2.68A3.12,3.12,0,0,1,151.88,56.64Zm5.25-.86A2.18,2.18,0,0,0,154.69,54,2,2,0,0,0,153,56.39a2.18,2.18,0,0,0,2.44,1.83A2.12,2.12,0,0,0,157.13,55.78Z"
            />
            <path
                className="cls-2"
                d="M164,51.51l.12,1.1a1.7,1.7,0,0,0-1.58,2.07l.49,3.18-1.1.12-1-6,1.1-.12.12,1A2.13,2.13,0,0,1,164,51.51Z"
            />
            <path
                className="cls-2"
                d="M170.43,55.9A2,2,0,0,0,172,54.8l1,.37A3.24,3.24,0,0,1,170.55,57a3,3,0,0,1-3.66-2.68,3.15,3.15,0,1,1,6.22-1v.49l-5,.85A2.11,2.11,0,0,0,170.43,55.9Zm-2.56-2.32,4-.61a2,2,0,0,0-2.19-1.46A2.09,2.09,0,0,0,167.87,53.58Z"
            />
            <rect
                className="cls-3"
                x="6.68"
                y="16.69"
                width="155.38"
                height="38.19"
                transform="translate(-4.6 13.82) rotate(-9.12)"
            />
            <path
                className="cls-2"
                d="M32.17,55.17c-3.41.61-6-.73-7.2-3.05l2.57-2.07a3.94,3.94,0,0,0,4.27,2c1.95-.37,2.56-1.34,2.32-2.2-.25-1.22-1.47-1.58-4-1.83s-5.37-1-5.86-4.15,1.83-5.37,4.64-5.85a6.5,6.5,0,0,1,6.59,2.68L33,42.72a3.12,3.12,0,0,0-3.54-1.58c-1.34.24-2.07,1.1-1.95,2.07s.85,1.47,3.54,1.83,5.73.86,6.34,4.27C37.91,52.24,35.84,54.56,32.17,55.17Z"
            />
            <path
                className="cls-2"
                d="M52.55,51.75a8.78,8.78,0,1,1,4.88-14.64l-2.56,2.08a5.09,5.09,0,0,0-4.76-1.71,5.22,5.22,0,0,0-4.51,6.34,5.17,5.17,0,0,0,6.34,4.52,4.76,4.76,0,0,0,3.91-3.05L59,46.51A8.48,8.48,0,0,1,52.55,51.75Z"
            />
            <path
                className="cls-2"
                d="M72.32,48.46c-3.66.61-6.71-1.1-7.32-4.76L63.17,32.47,66.46,32l1.83,11c.25,1.58,1.35,2.68,3.54,2.32s2.93-1.71,2.69-3.42l-1.83-11L76,30.28,77.81,41.5C78.3,45.16,76,47.85,72.32,48.46Z"
            />
            <polygon
                className="cls-2"
                points="92.45 44.68 89.16 45.29 86.84 31.74 82.33 32.47 81.84 29.3 94.16 27.23 94.65 30.4 90.14 31.13 92.45 44.68"
            />
            <polygon
                className="cls-2"
                points="109.66 41.87 106.37 42.48 104.05 28.93 99.53 29.67 99.04 26.5 111.37 24.42 111.86 27.59 107.34 28.32 109.66 41.87"
            />
            <polygon
                className="cls-2"
                points="120.28 40.04 117.47 23.32 120.77 22.71 123.08 36.26 129.43 35.16 129.92 38.33 120.28 40.04"
            />
            <polygon
                className="cls-2"
                points="136.14 37.35 133.33 20.64 143.58 18.93 144.07 22.1 137.12 23.32 137.73 26.86 144.07 25.76 144.56 28.81 138.22 29.91 138.82 33.69 145.9 32.47 146.39 35.65 136.14 37.35"
            />
        </svg>
    </>)
}


export function Logo({className}) {
    // @ts-ignore
    return <>
        {/*
  // @ts-ignore */}
        <svg
            className={clsx('logo', className)}
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 194.3 117.9"
            // style={{enableBackground: "new 0 0 194.3 117.9"}}
            xmlSpace="preserve"
        >
            <style
                type="text/css"
                dangerouslySetInnerHTML={{
                    __html:
                        "\n\t.st0{fill:#1E2D5C;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#FFFFFF;}\n"
                }}
            />
            <g>
                <path
                    className="st0"
                    d="M103.1,39.4c-0.9-1.5-1.7-2.7-2.1-2.5c-1,0.5-2.3-1.3-3.1-1.1C97,36,97.2,37.9,95.5,38
		c-1.7,0.2-2.1-5.1-2.9-5.1c-0.8,0-2.1,0.5-2.9,0c-1.4-0.9-1.3-5.3-3.6-6.1c-1.2-0.4-21.9,0.1-26.5,0.3c-4.6,0.2-7.3-0.5-9-0.2
		c-1.7,0.4-2,9.3-4.8,9.3c-2.7,0-0.9,0.1-2.6-0.8c-1.7-0.9-2.5-2.4-4.4-2.7c-1.9-0.4-2.1,3.6-4,3.6c-1.9,0-2.9,3.1-4.4,3.4
		c-1.5,0.4-1.9,5-4.2,5.4c-0.1,0-0.2,0.1-0.4,0.1l-6.2-1.1l-5.9,2.6c4.9-21.2,24-37,46.7-37c19.9,0,37,12.2,44.2,29.5l2.5-0.4
		C99.7,20.2,81.6,7.1,60.4,7.1C32.6,7.1,10,29.7,10,57.5c0,11.3,3.7,21.8,10.1,30.2c0,0,0,0.1,0.1,0.1c1.2,1.6,2.4,3,3.8,4.5
		c5.3,5.6,11.9,9.9,19.2,12.6c0.2,0.1,0.5,0.2,0.7,0.2c0.4,0.1,0.7,0.3,1.1,0.4c0.4,0.1,0.8,0.3,1.2,0.4c1.8,0.5,3.7,1,5.7,1.3
		c2.8,0.5,5.6,0.7,8.5,0.7c14,0,26.7-5.8,35.8-15l87.9-14.5l-3.3-20L61.3,77.6l-20.6-2.3l0.1-25.8L103.1,39.4z M24.9,77.4v12.2
		c-1-1.1-1.9-2.2-2.7-3.3c0,0,0,0,0,0V47l16.1,2.9V75l-3.5-0.4L24.9,77.4z M56.7,105.3c-1.5-0.1-2.9-0.3-4.3-0.5
		c-0.9-0.2-1.8-0.3-2.7-0.5v-2.5l-4.1-0.2v1.6c-0.3-0.1-0.6-0.2-0.9-0.3c-0.3-0.1-0.6-0.2-0.9-0.3v-1l-2.8-0.2
		c-1.3-0.6-2.6-1.2-3.9-1.9v-22l3.2,0.4l16.3,1.9V105.3z"
                />
            </g>
            <g>
                <polygon
                    className="st0"
                    points="55.5,100.9 51.4,100.7 51.4,98.5 55.5,98.7 	"
                />
                <polygon className="st0" points="43.9,100.2 39.8,100 39.8,97.7 43.9,98 	"/>
                <polygon className="st0" points="43.9,100.3 43.9,98 39.8,97.8 39.8,100 	"/>
                <polygon
                    className="st0"
                    points="55.5,97.7 51.4,97.4 51.4,95.2 55.5,95.5 	"
                />
                <polygon
                    className="st0"
                    points="43.9,96.8 39.8,96.6 39.8,94.3 43.9,94.6 	"
                />
                <polygon className="st0" points="45.6,91.4 49.7,91.7 49.7,94 45.6,93.6 	"/>
                <polygon className="st0" points="55.5,91.2 51.4,90.8 51.4,88.6 55.5,89 	"/>
                <polygon
                    className="st0"
                    points="43.9,90.1 39.8,89.8 39.8,87.5 43.9,87.9 	"
                />
                <polygon className="st0" points="55.5,88 39.8,86.3 39.8,84.1 55.5,85.7 	"/>
                <polygon className="st0" points="45.6,81.4 49.7,81.8 49.7,84 45.6,83.6 	"/>
                <polygon className="st0" points="43.9,83.4 39.8,83 39.8,80.7 43.9,81.2 	"/>
            </g>
            <linearGradient
                id="SVGID_1_"
                gradientUnits="userSpaceOnUse"
                x1="47.5849"
                y1="87.2886"
                x2="157.4304"
                y2="23.8693"
            >
                <stop offset={0} style={{stopColor: "#EF4136"}}/>
                <stop offset="5.558598e-02" style={{stopColor: "#EF4635"}}/>
                <stop offset="0.4069" style={{stopColor: "#F15D2C"}}/>
                <stop offset="0.7309" style={{stopColor: "#F26925"}}/>
                <stop offset={1} style={{stopColor: "#F26D23"}}/>
            </linearGradient>
            <path
                className="st1"
                d="M161,30L40.8,49.5l-0.1,25.8l20.6,2.3l104.3-16.7L161,30z M57.3,71.4c-2.8,0.5-4.9-0.6-5.9-2.5l2.1-1.7
	c0.7,1.2,1.8,1.8,3.5,1.6c1.6-0.3,2.1-1.1,1.9-1.8c-0.2-1-1.2-1.3-3.3-1.5c-2.2-0.3-4.4-0.8-4.8-3.4c-0.4-2.6,1.5-4.4,3.8-4.8
	c2.2-0.4,4.2,0.5,5.4,2.2l-2,1.7c-0.7-1-1.5-1.6-2.9-1.3c-1.1,0.2-1.7,0.9-1.6,1.7c0.1,0.8,0.7,1.2,2.9,1.5c2.3,0.3,4.7,0.7,5.2,3.5
	C62,69,60.3,70.9,57.3,71.4z M74,68.6c-4.1,0.7-7.6-1.9-8.3-5.9c-0.7-4,1.8-7.6,5.9-8.3c2.5-0.4,4.9,0.5,6.4,2.2l-2.1,1.7
	c-0.9-1.1-2.3-1.6-3.9-1.4c-2.7,0.4-4.1,2.6-3.7,5.2c0.4,2.6,2.5,4.2,5.2,3.7c1.6-0.3,2.8-1.2,3.2-2.5l2.6,1
	C78.5,66.5,76.5,68.1,74,68.6z M90.2,65.9c-3,0.5-5.5-0.9-6-3.9l-1.5-9.2l2.7-0.4l1.5,9c0.2,1.3,1.1,2.2,2.9,1.9
	c1.8-0.3,2.4-1.4,2.2-2.8l-1.5-9l2.7-0.5l1.5,9.2C95.1,63.2,93.2,65.4,90.2,65.9z M106.7,62.8l-2.7,0.5l-1.9-11.1l-3.7,0.6L98,50.2
	l10.1-1.7l0.4,2.6l-3.7,0.6L106.7,62.8z M120.8,60.5l-2.7,0.5l-1.9-11.1l-3.7,0.6l-0.4-2.6l10.1-1.7l0.4,2.6l-3.7,0.6L120.8,60.5z
	 M129.5,59l-2.3-13.7l2.7-0.5l1.9,11.1l5.2-0.9l0.4,2.6L129.5,59z M142.5,56.8l-2.3-13.7l8.4-1.4l0.4,2.6l-5.7,1l0.5,2.9l5.2-0.9
	l0.4,2.5l-5.2,0.9l0.5,3.1l5.8-1l0.4,2.6L142.5,56.8z"
            />
            <g>
                <path
                    className="st2"
                    d="M76.3,87.1c0.7-0.1,1.1-0.5,1.3-0.9l0.8,0.3c-0.3,0.7-1,1.3-2,1.5c-1.6,0.3-2.8-0.7-3-2.2
		c-0.2-1.4,0.6-2.7,2.2-3c1.5-0.2,2.6,0.8,2.9,2.2c0,0.1,0,0.3,0,0.4L74.4,86C74.7,86.9,75.4,87.3,76.3,87.1z M74.2,85.3l3.3-0.5
		c-0.3-0.9-1.1-1.3-1.8-1.2C74.8,83.8,74.2,84.4,74.2,85.3z"
                />
                <path
                    className="st2"
                    d="M84.6,86.5l-1.7-1.6L81.9,87l-1,0.2l1.5-2.8l-2.2-2.1l1-0.2l1.5,1.5l1-1.9l1-0.2l-1.4,2.7l2.3,2.2L84.6,86.5z"
                />
                <path
                    className="st2"
                    d="M92.9,82.7c0.2,1.4-0.7,2.8-2.1,3c-0.8,0.1-1.5-0.1-2-0.7l0.4,2.8l-0.9,0.1L87.4,81l0.9-0.1l0.1,0.8
		c0.3-0.7,0.9-1.1,1.7-1.3C91.4,80.3,92.7,81.2,92.9,82.7z M92.1,82.8c-0.2-1-1-1.6-2-1.5c-1,0.2-1.6,1-1.5,2c0.2,1,1,1.6,2,1.5
		C91.6,84.7,92.2,83.8,92.1,82.8z"
                />
                <path
                    className="st2"
                    d="M98.4,83.6c0.7-0.1,1.1-0.5,1.3-0.9l0.8,0.3c-0.3,0.7-1,1.3-2,1.5c-1.6,0.3-2.8-0.7-3-2.2
		c-0.2-1.4,0.6-2.7,2.2-3c1.5-0.2,2.6,0.8,2.9,2.2c0,0.1,0,0.3,0,0.4l-4.1,0.7C96.7,83.4,97.5,83.7,98.4,83.6z M96.3,81.8l3.3-0.5
		c-0.3-0.9-1.1-1.3-1.8-1.2C96.8,80.2,96.3,80.9,96.3,81.8z"
                />
                <path
                    className="st2"
                    d="M105.2,78.1l0.1,0.9c-0.7,0.1-1.5,0.6-1.3,1.7l0.4,2.6l-0.9,0.1l-0.8-4.9l0.9-0.1l0.1,0.8
		C104,78.5,104.6,78.2,105.2,78.1z"
                />
                <path
                    className="st2"
                    d="M107.4,76.3c-0.1-0.3,0.2-0.6,0.5-0.7c0.3-0.1,0.6,0.2,0.7,0.5c0,0.3-0.2,0.6-0.5,0.7
		C107.7,76.8,107.4,76.6,107.4,76.3z M107.8,77.8l0.9-0.1l0.8,4.9l-0.9,0.1L107.8,77.8z"
                />
                <path
                    className="st2"
                    d="M114.7,81c0.7-0.1,1.1-0.5,1.3-0.9l0.8,0.3c-0.3,0.7-1,1.3-2,1.5c-1.6,0.3-2.8-0.7-3-2.2
		c-0.2-1.4,0.6-2.7,2.2-3c1.5-0.2,2.6,0.8,2.9,2.2c0,0.1,0,0.3,0,0.4l-4.1,0.7C113,80.7,113.8,81.1,114.7,81z M112.6,79.1l3.3-0.5
		c-0.3-0.9-1.1-1.3-1.8-1.2C113.2,77.6,112.6,78.2,112.6,79.1z"
                />
                <path
                    className="st2"
                    d="M123.8,77.1l0.5,3l-0.9,0.1l-0.5-3c-0.1-0.8-0.7-1.2-1.4-1.1c-0.8,0.1-1.3,0.7-1.2,1.8l0.4,2.6l-0.9,0.1
		l-0.8-4.9l0.9-0.1l0.1,0.7c0.3-0.6,0.8-1,1.5-1.1C122.7,75.2,123.6,75.9,123.8,77.1z"
                />
                <path
                    className="st2"
                    d="M126.6,77.2c-0.2-1.4,0.7-2.8,2.2-3c1-0.2,1.9,0.2,2.4,0.9l-0.6,0.5c-0.3-0.5-0.9-0.7-1.6-0.6
		c-1,0.2-1.6,1-1.4,2c0.2,1,1,1.6,2,1.5c0.7-0.1,1.1-0.5,1.3-1.1l0.8,0.3c-0.3,0.8-1,1.5-2,1.6C128.1,79.6,126.8,78.7,126.6,77.2z"
                />
                <path
                    className="st2"
                    d="M136.5,77.5c0.7-0.1,1.1-0.5,1.3-0.9l0.8,0.3c-0.3,0.7-1,1.3-2,1.5c-1.6,0.3-2.8-0.7-3-2.2
		c-0.2-1.4,0.6-2.7,2.2-3c1.5-0.2,2.6,0.8,2.9,2.2c0,0.1,0,0.3,0,0.4l-4.1,0.7C134.8,77.2,135.6,77.6,136.5,77.5z M134.4,75.6
		l3.3-0.5c-0.3-0.9-1.1-1.3-1.8-1.2C134.9,74.1,134.4,74.7,134.4,75.6z"
                />
                <path
                    className="st2"
                    d="M152.6,72.4l0.5,3l-0.9,0.1l-0.5-3c-0.1-0.8-0.6-1.1-1.3-1c-0.7,0.1-1.1,0.6-1,1.7l0.4,2.7l-0.9,0.1l-0.5-3
		c-0.1-0.8-0.6-1.1-1.2-1c-0.7,0.1-1.2,0.6-1,1.7l0.4,2.7l-0.9,0.1l-0.8-4.9l0.9-0.1l0.1,0.7c0.3-0.6,0.7-0.9,1.3-1
		c0.7-0.1,1.2,0.1,1.6,0.6c0.3-0.6,0.8-1,1.4-1.1C151.5,70.6,152.4,71.2,152.6,72.4z"
                />
                <path
                    className="st2"
                    d="M155.4,72.6c-0.2-1.4,0.7-2.8,2.2-3c1.4-0.2,2.8,0.7,3,2.2c0.2,1.4-0.7,2.8-2.2,3
		C156.9,75,155.6,74.1,155.4,72.6z M159.7,71.9c-0.2-1-1-1.6-2-1.5c-1,0.2-1.6,1-1.4,2c0.2,1,1,1.6,2,1.5
		C159.2,73.8,159.8,72.9,159.7,71.9z"
                />
                <path
                    className="st2"
                    d="M165.3,68.4l0.1,0.9c-0.7,0.1-1.5,0.6-1.3,1.7l0.4,2.6l-0.9,0.1l-0.8-4.9l0.9-0.1l0.1,0.8
		C164.1,68.8,164.6,68.5,165.3,68.4z"
                />
                <path
                    className="st2"
                    d="M170.6,72c0.7-0.1,1.1-0.5,1.3-0.9l0.8,0.3c-0.3,0.7-1,1.3-2,1.5c-1.6,0.3-2.8-0.7-3-2.2
		c-0.2-1.4,0.6-2.7,2.2-3c1.5-0.2,2.6,0.8,2.9,2.2c0,0.1,0,0.3,0,0.4l-4.1,0.7C169,71.7,169.7,72.1,170.6,72z M168.5,70.1l3.3-0.5
		c-0.3-0.9-1.1-1.3-1.8-1.2C169.1,68.6,168.5,69.2,168.5,70.1z"
                />
            </g>
        </svg>
    </>;

}